import { render, staticRenderFns } from "./ComputersPanel.vue?vue&type=template&id=d5f9721e&"
import script from "./ComputersPanel.vue?vue&type=script&lang=js&"
export * from "./ComputersPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports